"use client";
import SVG from "react-inlinesvg";
import Link from "next/link";
import NewsList from "@/components/utils/NewsList";
import { rules } from "@/scripts/data";
import { InView } from "react-intersection-observer";

import { useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin)


export default function PageComponent({ posts }: { posts: any[] }) {
  const [kvClass, set_kvClass] = useState("standBy");
  const [kvClass2, set_kvClass2] = useState("");
  const isScrolled = useRef(false)

  const sectionBgPic = useRef(null);
  useGSAP(
    () => {
      const tl = gsap.timeline({delay: 0.5})
      tl.call(() => {if(!isScrolled.current)set_kvClass("")})
      if(!isScrolled.current) {
        tl.to(".pic",{clipPath: "inset(0% 0%)", duration:1, ease: "power3.out"})
        tl.to(".fadeOutContainer .logo",{opacity:1}, 1)
        tl.to(".button-holder",{opacity:1},1.5)
      } else {
        tl.set(".pic",{clipPath: "inset(0% 0%)", duration:1, ease: "power3.out"})
        tl.set(".fadeOutContainer .logo",{opacity:1})
        tl.set(".button-holder",{opacity:1})
      }
    },
    { scope: sectionBgPic }
  );

  const sectionTopKv = useRef(null);
  useGSAP(
    () => {
      ScrollTrigger.create({
        trigger: sectionTopKv.current,
        start: "top+=1px top",
        end: `bottom+=25% top`,
        onLeaveBack: () => {
          set_kvClass("");
        },
        onEnter: () => {
          isScrolled.current = true;
          set_kvClass("bgBorder");
        },
        onEnterBack: () => {
          isScrolled.current = true;
          set_kvClass("bgBorder back");
        },
        onLeave: () => {
          isScrolled.current = true;
          set_kvClass("bgFull");
        },
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionTopKv.current,
          start: "top+=1px top",
          end: "bottom-=25% top",
          scrub: 1,
          // markers: true,
        }
      });
      tl.fromTo(".base-bg-pic .pic img",{
        objectPosition: "50% 0%",
        top: "0%",
      },{
        objectPosition: "50% 100%",
        top: "-20%",
        duration:65,
      })
      tl.to(".block-top-statement .statement-bg",{opacity: 1, duration:20},65)
      tl.to(".block-top-statement .inner",{opacity: 1, duration:20},80)
    },
    { scope: sectionTopKv }
  );

  const sectionTopInstall = useRef(null);
  useGSAP(
    () => {
      ScrollTrigger.create({
        trigger: sectionTopInstall.current,
        start: "top top",
        onLeaveBack: () => {
          set_kvClass2("");
        },
        onEnter: () => {
          // ScrollTrigger.refresh();
          isScrolled.current = true;
          set_kvClass2("footerHide");
        },
      });
    },
    { scope: sectionTopInstall }
  );

  const revolutionList = useRef(null);
  const revolutionListItem1 = useRef(null);
  const revolutionListItem2 = useRef(null);
  useGSAP(
    () => {
      gsap.from(".revolution-list-item.n1",{
        opacity:0,
        y: 100,
        duration: 0.6,
        ease: "power3.out",
        scrollTrigger: {
          trigger: revolutionListItem1.current,
          start: "top-=150 center",
        }
      })
      gsap.from(".revolution-list-item.n2",{
        opacity:0,
        y: 100,
        duration: 0.6,
        delay: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: revolutionListItem2.current,
          start: "top-=150 center",
        }
      })
    },
    { scope: revolutionList }
  );

  const rulesList = useRef(null);
  useGSAP(
    () => {
      gsap.from(".rules-list-item",{
        opacity:0,
        y: 60,
        duration: 0.6,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: rulesList.current,
          start: "top-=100 center",
        }
      })
    },
    { scope: rulesList }
  );

  return (
    <main className={`page page-top`}>
      <section ref={sectionTopKv} className="section-top-kv">
        <div ref={sectionBgPic} className={`base-bg-pic ${kvClass} ${kvClass2}`}>
          <picture className="pic">
            <source srcSet="/assets/img/top/kv-1.jpg" media="(min-width: 1024px)" />
            <source srcSet="/assets/img/top/kv-1-sp.jpg" media="(max-width: 1024px)" />
            <img src="/assets/img/top/kv-1.jpg" alt="" />
          </picture>
          <div className="fadeOutContainer">
            <h1 className="logo">
              <span>
                <img src="/assets/img/top/logo-1.svg" alt="NEXT" />
              </span>
              <span>
                <img src="/assets/img/top/logo-2.svg" alt="GREEN" />
              </span>
              <span>
                <img src="/assets/img/top/logo-3.svg" alt="REVOLUTION" />
              </span>
            </h1>
            <div className="text-lead bold">
              <span>それは、</span>
              <span>おいしさにも地球にもいい</span>
              <span>土の革命。</span>
            </div>
          </div>
          <div className="button-holder">
            <button
              onClick={() => {
                gsap.to( window, {duration: 1.2,ease: 'power1.out',scrollTo: {y: 600,autoKill: true}});
              }}
              className="button-scroll en medi button-round scaleHover size-s"
              type="button"
            >
              <div className="inner">Scroll
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-bottom.svg" />
                </i>
              </div>
            </button>
          </div>
        </div>

        <div className="block-top-statement">
          <div className="statement-bg"></div>
          <div className="inner">
            <h2 className="statement-title">
              <span className="en">
                <span className="pink">Next</span> Green <br className="spOnly" />Revolution
              </span>
              とは
            </h2>
            <p className="statement bold">
              食べる人とつくる人が、
              <br className="spOnly" />
              共に、
              <br className="pcOnly" />
              「おいしい」も「地球にいい」も
              <br className="spOnly" />
              叶えていく土の革命です。
              <br />
              2つの柱と、10の合言葉で
              <br className="spOnly" />
              できています。
            </p>
          </div>
        </div>
      </section>

      <section className="section section-top-revolution">
        <div className="container-m">
          <h2 className="section-top-title">
            <span className="title-main">
              <span className="en">
                <span className="pink">Next</span> Green Revolution
              </span>
              を<br />
              支える2つの柱
            </span>
          </h2>
          <p className="text-lead bold">
            「食べる革命」と「つくる革命」。<br />
            生活者（食べ手）と農家（つくり手）をつなぎ、それぞれに新たな価値を届けます。
          </p>
        </div>
        <div className="container-l">
          <ul ref={revolutionList} className="revolution-list">
            <InView>
              {({ inView, ref, entry }) => (
                <li ref={ref} className="revolution-list-item round n1">
                  <div className="trigger" ref={revolutionListItem1}></div>
                  <p className="shoulder bold">
                    <span className="en">1</span>
                    <span>食べる革命</span>
                  </p>
                  <h3 className="title en">
                    <span className="small">Next Green</span>
                    <span>Vegetables</span>
                  </h3>
                  <div className="box-info">
                    <div className="box-pic">
                      <figure className="pic">
                        <span className="badge"><img src="/assets/img/top/badge-vegetables.svg" alt="" /></span>
                        {inView && <video className="Vegetables" src="/assets/video/ngv.mp4" loop autoPlay muted playsInline />}
                      </figure>
                    </div>
                    <div className="box-text">
                      <p className="text-catch bold">土からおいしい野菜へ</p>
                      <p className="text-read">
                        <span>日本で初めての「おいしい理由が見える野菜」です。土がちがうから、おいしさもちがう。土が健康だから、野菜も健康。</span>
                        <span>そんな「土」にこだわるおいしい野菜を、次の時代のスタンダードへと変えていきます。</span>
                      </p>
                      <div className="button-holder">
                        <Link className="scaleHover button-round scaleHover size-m" href="/vegetables/">
                          <span className="inner">くわしく見る</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              )}
            </InView>
            <InView>
                {({ inView, ref, entry }) => (
                <li ref={ref} className="revolution-list-item round n2">
                  <div className="trigger" ref={revolutionListItem2}></div>
                  <p className="shoulder bold">
                    <span className="en">2</span>
                    <span>つくる革命</span>
                  </p>
                  <h3 className="title en">
                    <span className="small">Next Green</span>
                    <span>Method</span>
                  </h3>
                  <div className="box-info">
                    <div className="box-pic">
                      <figure className="pic">{inView && <video className="method" src="/assets/video/ngm.mp4" loop autoPlay muted playsInline />}</figure>
                    </div>
                    <div className="box-text">
                      <p className="text-catch bold">土から健康な農業へ</p>
                      <p className="text-read">
                        <span>おいしく育つ土づくりの「Soil Solution」。土壌の価値を可視化する「Agri LCA+」。土づくりの好影響を価値化する「Next Green Credit」。</span>
                        <span>3つが連携し、おいしい野菜が生まれ、地球環境にとってもいい畑へと導きます。</span>
                      </p>
                      <div className="button-holder">
                        <Link className="scaleHover button-round scaleHover size-m" href="/method/">
                          <span className="inner">くわしく見る</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              )}
            </InView>
          </ul>
          <div className="logo-list-wrapper full-width-sp">
            <ul className="logo-list">
              <li className="logo-list-item">
                <img src="/assets/img/top/join-logo-1.svg" alt="産業技術総グループ AIST GROUP" />
              </li>
              <li className="logo-list-item">
                <img src="/assets/img/top/join-logo-2.png" alt="RIKEN" />
              </li>
              <li className="logo-list-item">
                <img src="/assets/img/top/join-logo-3.png" alt="京都大学 Kyoto University" />
              </li>
              <li className="logo-list-item">
                <img src="/assets/img/top/join-logo-4.png" alt="東京農業大学" />
              </li>
              <li className="logo-list-item">
                <img src="/assets/img/top/join-logo-5.png" alt="国立大学法人 福島大学" />
              </li>
            </ul>
          </div>
          <div className="logo-list-text">
            農業を革新し、全ての農家が実践可能な未来を目指すため、
            <br />
            大学や研究機関の知見を結集して開発してきました。
          </div>
        </div>
      </section>

      <section className="section section-top-10rules">
        <h2 className="section-top-title">
          <span className="title-main">10の合言葉</span>
        </h2>
        <p className="text-lead bold">
          おいしさにも地球にもいい土の革命
          <br />
          Next Green Revolutionを叶えるために。
          <br />
          みんなで掲げる合言葉です。
        </p>

        <div ref={rulesList} className="rules-list">
          {rules.map((item, i) => (
            <div className={`rules-list-item n${item.id}`} key={item.id}>
              <div className="pic">
                <img src={`/assets/img/rules/thumbnail/pic-${item.id}.jpg`} alt="" loading="lazy" />
              </div>
              <div className="rules-title">
                <div className="number bold en">{item.id}</div>
                <h2 className="title bold" dangerouslySetInnerHTML={{ __html: item.title }}></h2>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section section-top-10rules-2">
        <div className="container-m">
          <div className="text-lead bold">
            人類にも地球にもいい農業へ。
            <br />
            農家・研究機関・企業・生活者が垣根を<br className="spOnly" />超えて、
            <br className="pcOnly" />
            共に新たな農業の未来をつくる。
            <br />
            Next Green Revolutionは、<br className="spOnly" />みんなで起こす革命です。
          </div>
        </div>
      </section>

      <section ref={sectionTopInstall} className="section section-top-install">
        <div className="container-m">
          <h2 className="section-top-title">
            <span className="title-main">参加の方法</span>
            <span className="title-sub en medi">How to Join</span>
          </h2>
          <ul className="list-for">
            <li className="list-for-item">
              <Link className="link scaleHover" href="/for-farmers/">
                <div className="inner">
                  <h3 className="title-holder">
                    <span className="title-main bold">農家のみなさまへ</span>
                    <span className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                    </span>
                  </h3>
                  <p className="title-sub">For Farmers</p>
                  <div className="description">どんな農法の方でも、収量はそのままに、よりおいしく、よりサステナブルな農業を目指せます。</div>
                </div>
              </Link>
            </li>
            <li className="list-for-item">
              <Link className="link scaleHover" href="/for-companies/">
                <div className="inner">
                  <h3 className="title-holder">
                    <span className="title-main bold">企業のみなさまへ</span>
                    <span className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                    </span>
                  </h3>
                  <p className="title-sub en medi">For Companies</p>
                  <div className="description">Next Green Revolutionは、どんな企業でも参加でき、事業を通じて、農業や食、土や水も守るサステナブルな未来を支えられます。</div>
                </div>
              </Link>
            </li>
            <li className="list-for-item">
              <Link className="link scaleHover" href="/for-everyone/">
                <div className="inner">
                  <h3 className="title-holder">
                    <span className="title-main bold">みなさまへ</span>
                    <span className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                    </span>
                  </h3>
                  <p className="title-sub en medi">For Everyone</p>
                  <div className="description">Next Green Revolutionは、だれもがたのしく参加できる、おいしく健康な新しい食と農の運動です。</div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </section>
      {posts.length > 0 && (
        <section className="section section-top-news">
          <div className="container-m">
            <div className="col-between">
              <h2 className="section-top-title">
                <span className="title-main en">News</span>
                <span className="title-sub">お知らせ</span>
              </h2>
              <div className="container-news">
                <NewsList posts={posts} itemsPerPage={5} />
                <Link className="button-link button-round scaleHover size-s" href="/news/">
                  <span className="inner">すべてのお知らせを見る</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}
    </main>
  );
}
